<template>
	<div>
		<v-tabs class="template-tab" fixed-tabs v-model="active">
			<v-tab
				v-for="(tab, indexTab) in tabs"
				:key="indexTab"
			>
				{{ tab }}
			</v-tab>
			<v-tab-item>
				<presents-table
					class="presents-wrapper"
					:columns="columns"
					:rows="presentsAlreadyGot"
				/>
			</v-tab-item>
			<v-tab-item>
				<presents-table
					class="presents-wrapper"
					:columns="columnsComputed"
					:rows="presentsIwant"
				/>
			</v-tab-item>
		</v-tabs>
	</div>
</template>
<script>
import presentsTable from '@/components/configuration/employees/presentsTable';
import { mapState } from 'vuex';

async function created() {
	await this.$store.dispatch(
		'presentsConfiguration/loadPresentsByEmployee',
		this.$route.params.employeeId,
	);
}

function columnsComputed() {
	return [].concat(this.columns, { name: 'ACCIÓN' });
}

function data() {
	return {
		active: 2,
		columns: [
			{ name: 'REGALO' },
			{ name: 'PUNTAJE' },
		],
		tabs: ['REGALOS RECIBIDOS', 'REGALOS A ESCOGER'],
	};
}

export default {
	name: 'assignment-presents-component',
	components: {
		presentsTable,
	},
	computed: {
		...mapState('presentsConfiguration', {
			presentsIwant: state => state.presentsByEmployee.pending,
			presentsAlreadyGot: state => state.presentsByEmployee.gotIt,
		}),
		columnsComputed,
	},
	created,
	data,
};
</script>
<style lang="scss" scoped>
.presents-wrapper {
	margin: 20px 36px;
}
</style>


// WEBPACK FOOTER //
// src/components/configuration/employees/assignmentPresentsComponent.vue